import { render, staticRenderFns } from "./FathomConfiguration.vue?vue&type=template&id=4803526d&scoped=true"
import script from "./FathomConfiguration.vue?vue&type=script&lang=js"
export * from "./FathomConfiguration.vue?vue&type=script&lang=js"
import style0 from "./FathomConfiguration.vue?vue&type=style&index=0&id=4803526d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4803526d",
  null
  
)

export default component.exports